import { autoinject, bindable } from 'aurelia-framework';
import './loader.scss';

@autoinject()
export class Loader {
  @bindable dark = false;
  constructor() {}
}
